import { useQuery } from "@apollo/client";
import { FacilityJoinableEpisodicEventsQuery } from "generated-graphql/graphql";

import { FACILITY_JOINABLE_EPISODIC_EVENTS_QUERY } from "./api";
import { PreviewEpisodicEvent } from "./containerClockPreview";

export type JoinableEpisodicEvent = NonNullable<
  NonNullable<FacilityJoinableEpisodicEventsQuery["facility"]>["episodicEvents"]
>["items"][number];

/**
 * The events at a facility a container being created there could join.
 *
 * Skipped without a facility, because until one is chosen there is nothing to
 * ask about — and the create form opens with the field blank whenever it isn't
 * scoped to a facility already.
 */
export function useJoinableEpisodicEvents(facilityId: string): JoinableEpisodicEvent[] {
  const { data } = useQuery(FACILITY_JOINABLE_EPISODIC_EVENTS_QUERY, {
    variables: { facilityId },
    skip: !facilityId,
  });
  return data?.facility?.episodicEvents?.items ?? [];
}

/** The event the form has actually chosen to attach to, if any. */
export function chosenEpisodicEvent(
  events: JoinableEpisodicEvent[],
  episodicEventId: string | null
): PreviewEpisodicEvent | undefined {
  const chosen = events.find((event) => event.id === episodicEventId);
  if (!chosen) {
    return undefined;
  }
  return {
    reason: chosen.reason,
    startDate: chosen.startDate,
    accumulationDeadline: chosen.accumulationDeadline,
  };
}
